import React from 'react';
import WelcomeModal from './modals/WelcomeModal';
import CacheConsentModal from './modals/CacheConsentModal';
import { useWelcomeModal } from '../hooks/useWelcomeModal';
import { useCacheConsent } from '../hooks/useCacheConsent';

export default function ModalsWrapper() {
  const { isOpen, closeModal } = useWelcomeModal();
  const { showConsent, closeConsent } = useCacheConsent();

  return (
    <>
      <WelcomeModal isOpen={isOpen} onClose={closeModal} />
      <CacheConsentModal isOpen={showConsent} onClose={closeConsent} />
    </>
  );
}